module.exports = __webpack_public_path__ + "media/images/mare_fee-d585f2c0f71d264a4051fe957d3910fc.png";